<template>
  <svg :class="{'scroll-button': true, 'scroll-button--left': left}" width="100%" height="100%" viewBox="0 0 102 136" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M99 6V3H96H68C32.1015 3 3 32.1015 3 68C3 103.899 32.1015 133 68 133H96H99V130V6Z" :fill="`url(#${color})`" stroke="white" stroke-width="6"/>
    <ellipse cx="43.4332" cy="21.1556" rx="10" ry="5.70339" transform="rotate(-22.9856 43.4332 21.1556)" fill="white" fill-opacity="0.3"/>
    <path d="M46 44L68.5 68.5L46 93" stroke="white" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
    <defs >
      <linearGradient id="blue" x1="0" y1="0" x2="0" y2="124" gradientUnits="userSpaceOnUse">
        <stop offset="0.0833333" stop-color="#4CBFFF"/>
        <stop offset="1" stop-color="#59D4E4"/>
      </linearGradient>
      <linearGradient id="purple" x1="45" y1="0" x2="45" y2="124" gradientUnits="userSpaceOnUse">
        <stop stop-color="#EB9CFF"/>
        <stop offset="1" stop-color="#A217AB"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'scroll-button-icon',
  props: {
    color: {
      type: String,
      validator: s => ['blue', 'purple'].includes(s)
    },
    left: Boolean
  }
}
</script>

<style lang="scss">
.scroll-button {
  &--left {
    transform: rotateY(180deg);
  }
}
</style>
